import React, { useState, useRef, useMemo } from "react";
import { dummyData } from "./claimTrendCharts/data";
import DynamicChart from "./claimTrendCharts/DynamicChart";
import GlobalFilters from "~src/features/globalFilters/index";
import ProviderNetworkPredictions from "./ProviderNetwrorkPrediction";
// import RGL, { Responsive, WidthProvider } from "react-grid-layout";
import { Responsive as ResponsiveGridLayout } from "react-grid-layout";
import { CONSTPROVIDERLIST, MAXPROVIDERCOUNT } from "~src/data/forecastFilters";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

// const ResponsiveGridLayout = WidthProvider(RGL);
const DialogExample = () => {
  const parentRef = useRef(null);
  const mapRef = useRef(null);
  const initialLayouts = {
    lg: [
      { w: 6, h: 6, x: 0, y: 0, i: "a", moved: false, static: false },
      { w: 3, h: 6, x: 9, y: 0, i: "b", moved: false, static: false },
      { w: 3, h: 6, x: 6, y: 0, i: "c", moved: false, static: false },
      { w: 12, h: 4, x: 0, y: 6, i: "d", moved: false, static: false },
      { w: 12, h: 4, x: 0, y: 6, i: "e", moved: false, static: false },
    ],
  };
  const uniqueKey = `res${Date.now()}`;
  const [providersList, setProvidersList] = useState({ ...CONSTPROVIDERLIST });
  const [layouts, setLayouts] = useState(initialLayouts);
  const onLayoutChange = (_, allLayouts) => {
    setLayouts(() => allLayouts);
  };
  const handleAddProvider = () => {
    if (Object.keys(providersList).length < MAXPROVIDERCOUNT) {
      const newProvider = {
        "provider-group": [],
        emirate: [],
        "provider-type": [],
        "provider-name": [],
        "clinician-speciality": [],
        "clinician-name": [],
        "transaction-fromdate": ["01-01-2022"],
        "transaction-todate": ["31-12-2022"],
        "claim-status": ["partially_paid", "paid", "open", "rejected"],
        "claim-type": ["1"],
        encounter: ["outpatient"],
      };

      const providersListClone = { ...providersList };
      providersListClone[Object.keys(providersListClone).length] = newProvider;
      setProvidersList({ ...providersListClone });
    }
  };

  return (
    <div>
      {Object.keys(providersList).map((provider, providerIdx) => (
        <GlobalFilters
          key={`${provider}_global_filter`}
          providerLabel={provider}
          setProvider={setProvidersList}
          provider={providersList}
          handleAddProvider={handleAddProvider}
          providerIdx={providerIdx}
        />
      ))}

      <ResponsiveGridLayout
        key={`res${uniqueKey}`}
        layouts={layouts}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
        rowHeight={60}
        width={window.screen.width - 150}
        onLayoutChange={onLayoutChange}
        style={{ marginTop: "3rem" }}
      >
        {Object.keys(dummyData).map((dataKey, index) => {
          const dataExtract = dummyData[dataKey];
          return Object.keys(dataExtract).map((Key, dataIndex) => {
            const dataToUse = dummyData[dataKey][Key];
            if (!Array.isArray(dataToUse)) {
              return null;
            }
            const y = index + dataIndex * 3;
            return (
              <div
                key={`${index}_${dataIndex}_container`}
                className="widget "
                data-grid={{
                  w: dataToUse[4].w,
                  h: dataToUse[4].h,
                  x: dataToUse[4].x,
                  y: dataToUse[4].y,
                  marginTop: "12rem",
                }}
                // style={{
                //   marginTop: index === 3 || index === 4 ? "10%" : null,
                // }}
              >
                <DynamicChart
                  isOptionsEnabled={
                    dataToUse[0] === "Claim Trends" ? true : false
                  }
                  title={dataToUse[0]}
                  data={dataToUse[1]}
                  options={dataToUse[2]}
                  type={dataToUse[3]}
                />
              </div>
            );
          });
        })}

        <div
          key={`provider_predictions_container`}
          className="widget "
          data-grid={{ w: 6, h: 5, x: 6, y: 5 }}
        >
          <ProviderNetworkPredictions mapRef={mapRef} />
        </div>
      </ResponsiveGridLayout>
    </div>
  );
};

export default DialogExample;
